import { grayColor, cardTitle } from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const sectionBlogInfoStyle = createStyles({
  section: {
    paddingTop: "30px",
    paddingBottom: "0",
    backgroundPosition: "50%",
    backgroundSize: "cover",
    padding: "70px 0"
  },
  blogTags: {
    marginTop: "8px"
  },
  buttons: {
    marginTop: "0",
    marginBottom: "0",
    float: "right !important" as "right"
  },
  card: {
    marginTop: "0",
    textAlign: "left"
  },
  cardTitle,
  description: {
    fontSize: "1rem",
    color: grayColor[0]
  },
  pullRight: {
    marginTop: "25px",
    float: "right"
  }
});

export default sectionBlogInfoStyle;
